var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useEffect, useReducer } from "react";
import { useSelector } from "react-redux";
import ReactPixel from "react-facebook-pixel";
import { WidgetContext } from "./components/Widget";
var AnalyticsActionType;
(function (AnalyticsActionType) {
    AnalyticsActionType[AnalyticsActionType["setGoogleProperties"] = 0] = "setGoogleProperties";
    AnalyticsActionType[AnalyticsActionType["clearGoogleProperties"] = 1] = "clearGoogleProperties";
    AnalyticsActionType[AnalyticsActionType["setFacebookIds"] = 2] = "setFacebookIds";
    AnalyticsActionType[AnalyticsActionType["clearFacebookIds"] = 3] = "clearFacebookIds";
})(AnalyticsActionType || (AnalyticsActionType = {}));
var notImplemented = function () {
    console.log("Analytics function not implemented yet");
};
export var AnalyticsContext = React.createContext({
    data: {
        googleProperties: [],
        facebookIds: [],
    },
    setGoogleProperties: function (ids) {
        console.log("Analytics function not implemented yet");
    },
    clearGoogleProperties: notImplemented,
    setFacebookIds: function (facebookIds) {
        console.log("Analytics function not implemented yet");
    },
    clearFacebookIds: notImplemented,
    addToCart: function (cartAddInput, event) {
        console.log("AddToCart function not implemented yet");
    },
    removeFromCart: function (attendees, event) {
        console.log("RemoveFromCart function not implemented yet");
    },
    startCheckout: function (event, cart) {
        console.log("StartCheckout function not implemented yet");
    },
    purchase: function (transactionId, event, cart) {
        console.log("StartCheckout function not implemented yet");
    },
    logPageview: function () {
        console.log("Pageview function not implemented yet");
    },
});
var useTypedSelector = useSelector;
var dataLayerMessagePrefix = "bfAnalytics";
var AnalyticsProvider = function (_a) {
    var children = _a.children, isWidget = _a.isWidget, debugMode = _a.debugMode;
    var attendeeTypeData = useTypedSelector(function (store) { return store.attendees; }).attendeeTypeData;
    var gaSessions = useContext(WidgetContext).gaSessions;
    var createMessage = function (obj) {
        // This creates a consistent message shape to post up to the top window.
        //It needs to match the shape of createMessageFromEvent
        if (!Array.isArray(obj) && typeof obj === "object") {
            var flattenObj = JSON.parse(JSON.stringify(obj));
            var message = {};
            // Add metadata about the page into the message
            message[dataLayerMessagePrefix] = {
                pageData: {
                    url: document.location.href,
                    title: document.title,
                },
            };
            for (var prop in flattenObj) {
                if (flattenObj.hasOwnProperty(prop) && prop !== "gtm.uniqueEventId") {
                    if (prop === "event") {
                        message.event = dataLayerMessagePrefix + "." + flattenObj[prop];
                    }
                    else {
                        message[dataLayerMessagePrefix][prop] = flattenObj[prop];
                    }
                }
            }
            if (!message.event)
                message.event = dataLayerMessagePrefix + ".Message";
            return message;
        }
        return false;
    };
    var createMessageFromEvent = function (eventName, payload) {
        // This creates a consistent message shape to post up to the top window.
        //It needs to match the shape of createMessage
        var message = {};
        // Add metadata about the page into the message
        message[dataLayerMessagePrefix] = {
            pageData: {
                url: document.location.href,
                title: document.title,
            },
        };
        message[dataLayerMessagePrefix][0] = "event";
        message[dataLayerMessagePrefix][1] = eventName;
        message[dataLayerMessagePrefix][2] = payload;
        message.event = dataLayerMessagePrefix + ".Message";
        return message;
    };
    var initDataLayerInterceptor = function () {
        //We're going to capture the window.dataLayer.push event so we can
        //stop any gtag events which need to go to the top window instead.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        if (!window.oldPush) {
            // Create the push listener for future messages
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            window.oldPush = window.dataLayer.push;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        window.dataLayer.push = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var states = [].slice.call(args, 0);
            states
                .filter(function (state) { var _a; return !!gaSessions[(_a = state[2]) === null || _a === void 0 ? void 0 : _a["send_to"]]; })
                .forEach(function (arg) {
                var _a;
                //This loops over all the events which need to go to the top window and sends them
                var message = createMessage(arg);
                if (message) {
                    if (debugMode) {
                        console.log("Sending ga event to parent", message);
                    }
                    (_a = window.top) === null || _a === void 0 ? void 0 : _a.postMessage(message, "*");
                }
            });
            states
                .filter(function (state) { var _a; return !gaSessions[(_a = state[2]) === null || _a === void 0 ? void 0 : _a["send_to"]]; })
                .forEach(function (arg) {
                if (debugMode) {
                    console.log("Sending ga event to self", arg);
                }
            });
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var filteredStates = states.filter(function (state) { var _a; return !gaSessions[(_a = state[2]) === null || _a === void 0 ? void 0 : _a["send_to"]]; });
            if (filteredStates.length > 0) {
                //We apply all the other events (for this window) and apply them back
                //to the dataLayer so they are processed normally
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                return window.oldPush.apply(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                window.dataLayer, filteredStates);
            }
        };
    };
    useEffect(function () {
        if (gaSessions && Object.keys(gaSessions).length > 0) {
            //If this is the widget, and there are GA settings on the top window
            //we intercept the dataLayer.push function
            initDataLayerInterceptor();
        }
    }, [gaSessions]);
    var _b = __read(useReducer(function (state, action) {
        var newState = Object.assign({}, state);
        switch (action.type) {
            case AnalyticsActionType.setGoogleProperties:
                action.payload.forEach(function (googleProperty) {
                    if (!newState.googleProperties.find(function (p) { return p.number === googleProperty.number; })) {
                        newState.googleProperties.push(googleProperty);
                        if (debugMode) {
                            console.log("Initializing GA property", googleProperty.number);
                        }
                        if (gaSessions[googleProperty.number]) {
                            if (window.brushfireDebugMode === "true" || window.brushfireDebugMode === true) {
                                console.log("Connecting to Google Analytics session with client id \"".concat(gaSessions[googleProperty.number].clientId, "\" and session id \"").concat(gaSessions[googleProperty.number].sessionId, "\""));
                            }
                            gtag("config", googleProperty.number, {
                                send_page_view: false,
                                cookie_flags: "samesite=none;secure",
                                linker: googleProperty.domain !== ""
                                    ? {
                                        domains: googleProperty.domain.split(","),
                                    }
                                    : undefined,
                                client_id: gaSessions[googleProperty.number].clientId,
                                session_id: gaSessions[googleProperty.number].sessionId,
                            });
                        }
                        else {
                            gtag("config", googleProperty.number, {
                                send_page_view: false,
                                cookie_flags: "samesite=none;secure",
                                linker: googleProperty.domain !== ""
                                    ? {
                                        domains: googleProperty.domain.split(","),
                                    }
                                    : undefined,
                            });
                        }
                    }
                });
                return newState;
            case AnalyticsActionType.clearGoogleProperties:
                newState.googleProperties = [];
                return newState;
            case AnalyticsActionType.setFacebookIds:
                action.payload.forEach(function (facebookId) {
                    if (!newState.facebookIds.includes(facebookId)) {
                        newState.facebookIds.push(facebookId);
                        ReactPixel.init(facebookId, undefined, { debug: false, autoConfig: true });
                    }
                });
                return newState;
            case AnalyticsActionType.clearFacebookIds:
                newState.facebookIds = [];
                return newState;
        }
        return state;
    }, {
        googleProperties: [],
        facebookIds: [],
    }), 2), analyticsStateData = _b[0], setAnalyticsStateData = _b[1];
    var setGoogleProperties = function (googleProperties) {
        setAnalyticsStateData({
            type: AnalyticsActionType.setGoogleProperties,
            payload: googleProperties,
        });
    };
    var clearGoogleProperties = function () {
        setAnalyticsStateData({
            type: AnalyticsActionType.clearGoogleProperties,
        });
    };
    var setFacebookIds = function (facebookIds) {
        setAnalyticsStateData({
            type: AnalyticsActionType.setFacebookIds,
            payload: facebookIds,
        });
    };
    var clearFacebookIds = function () {
        setAnalyticsStateData({
            type: AnalyticsActionType.clearFacebookIds,
        });
    };
    var sendGoogleAnalyticsEvent = function (eventName, payload) {
        //Page views are automatically logged by GA4, so we don't want to double those
        if (eventName !== "page_view") {
            //Always send every event specifically to our internal GA4 property
            if (debugMode) {
                console.log("Sending ga Brushfire Property", isWidget ? "G-DHE52CN562" : "G-5K0HHYVXDF");
            }
            gtag("event", eventName, __assign(__assign({}, payload), { send_to: isWidget ? "G-DHE52CN562" : "G-5K0HHYVXDF" }));
            if (analyticsStateData.googleProperties.length) {
                analyticsStateData.googleProperties.forEach(function (googleProperty) {
                    var _a;
                    //Send every event to every event GA4 property
                    if (!gaSessions[googleProperty.number]) {
                        //This property DOES NOT exist in a parent window, so send the event like normal
                        gtag("event", eventName, __assign(__assign({}, payload), { send_to: googleProperty.number }));
                    }
                    else {
                        //This property exists in a parent window, so post the data to the top window
                        //and let the client.js script handle it
                        var message = createMessageFromEvent(eventName, __assign(__assign({}, payload), { send_to: googleProperty.number }));
                        if (debugMode) {
                            console.log("Sending ga event to parent", message);
                        }
                        (_a = window.top) === null || _a === void 0 ? void 0 : _a.postMessage(message, "*");
                    }
                });
            }
        }
    };
    var addToCart = function (cartAddInput, event) {
        var _a, _b, _c;
        var total = 0;
        (_a = cartAddInput.attendees) === null || _a === void 0 ? void 0 : _a.forEach(function (attendee) {
            total += attendee.amount * attendee.quantity;
        });
        var payload = {
            currency: event.currency,
            value: total,
            items: (_b = cartAddInput.attendees) === null || _b === void 0 ? void 0 : _b.map(function (cartAddInputAttendee) {
                var att = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.find(function (a) { return a.id === cartAddInputAttendee.typeId; });
                if (att) {
                    return {
                        item_name: "".concat(event.titleInfo, " (").concat(att.name, ")"),
                        currency: event.currency,
                        price: cartAddInputAttendee.amount,
                        quantity: cartAddInputAttendee.quantity,
                    };
                }
            }),
        };
        sendGoogleAnalyticsEvent("add_to_cart", payload);
        if (debugMode) {
            console.log("GA Event: Add to cart");
        }
        if (analyticsStateData.facebookIds.length) {
            var payload_1 = {
                content_name: event.titleInfo,
                content_type: event.verbiage,
                contents: (_c = cartAddInput.attendees) === null || _c === void 0 ? void 0 : _c.map(function (cartAddInputAttendee) {
                    var att = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.find(function (a) { return a.id === cartAddInputAttendee.typeId; });
                    if (att) {
                        return {
                            id: att.name,
                            quantity: cartAddInputAttendee.quantity,
                        };
                    }
                }),
                currency: event.currency,
                value: total,
            };
            ReactPixel.track("AddToCart", payload_1);
        }
    };
    var removeFromCart = function (attendees, event) {
        var total = 0;
        attendees.forEach(function (attendee) {
            total += attendee.unitPrice;
        });
        if (analyticsStateData.googleProperties.length) {
            var consolidatedAttendeeItems_1 = {};
            attendees.forEach(function (cartAttendee) {
                if (!consolidatedAttendeeItems_1.hasOwnProperty("".concat(cartAttendee.attendeeTypeId, "-").concat(cartAttendee.unitTotal.toString()))) {
                    var att = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.find(function (a) { return a.id === cartAttendee.attendeeTypeId; });
                    if (att) {
                        consolidatedAttendeeItems_1["".concat(cartAttendee.attendeeTypeId, "-").concat(cartAttendee.unitTotal.toString())] = {
                            item_name: "".concat(event.titleInfo, " (").concat(att.name, ")"),
                            currency: event.currency,
                            price: cartAttendee.unitTotal,
                            quantity: 0,
                        };
                    }
                }
                if (consolidatedAttendeeItems_1["".concat(cartAttendee.attendeeTypeId, "-").concat(cartAttendee.unitTotal.toString())]) {
                    consolidatedAttendeeItems_1["".concat(cartAttendee.attendeeTypeId, "-").concat(cartAttendee.unitTotal.toString())]
                        .quantity++;
                }
            });
            var payload = {
                currency: event.currency,
                value: total,
                items: Object.values(consolidatedAttendeeItems_1),
            };
            sendGoogleAnalyticsEvent("remove_from_cart", payload);
            if (debugMode) {
                console.log("GA Event: Remove from cart");
            }
        }
    };
    var startCheckout = function (event, cart) {
        var _a;
        var total = cart.total;
        var consolidatedAttendeeItems = {};
        (_a = cart.attendees) === null || _a === void 0 ? void 0 : _a.forEach(function (cartAttendee) {
            if (!consolidatedAttendeeItems.hasOwnProperty("".concat(cartAttendee.attendeeTypeId, "-").concat(cartAttendee.unitTotal.toString()))) {
                var att = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.find(function (a) { return a.id === cartAttendee.attendeeTypeId; });
                if (att) {
                    consolidatedAttendeeItems["".concat(cartAttendee.attendeeTypeId, "-").concat(cartAttendee.unitTotal.toString())] = {
                        item_name: "".concat(event.titleInfo, " (").concat(att.name, ")"),
                        currency: event.currency,
                        price: cartAttendee.unitTotal,
                        quantity: 0,
                    };
                }
            }
            if (consolidatedAttendeeItems["".concat(cartAttendee.attendeeTypeId, "-").concat(cartAttendee.unitTotal.toString())]) {
                consolidatedAttendeeItems["".concat(cartAttendee.attendeeTypeId, "-").concat(cartAttendee.unitTotal.toString())]
                    .quantity++;
            }
        });
        if (analyticsStateData.googleProperties.length) {
            var payload = {
                currency: event.currency,
                value: total,
                items: Object.values(consolidatedAttendeeItems),
            };
            sendGoogleAnalyticsEvent("begin_checkout", payload);
            if (debugMode) {
                console.log("GA Event: Begin checkout");
            }
        }
        if (analyticsStateData.facebookIds.length) {
            var payload = {
                num_items: cart.attendeeCount,
                currency: event.currency,
                value: total,
                contents: Object.values(consolidatedAttendeeItems).map(function (i) { return ({
                    id: i.item_name,
                    quantity: i.quantity,
                }); }),
            };
            ReactPixel.track("InitiateCheckout", payload);
        }
    };
    var purchase = function (transactionId, event, cart) {
        var _a;
        var total = cart.total;
        var consolidatedAttendeeItems = {};
        (_a = cart.attendees) === null || _a === void 0 ? void 0 : _a.forEach(function (cartAttendee) {
            if (!consolidatedAttendeeItems.hasOwnProperty("".concat(cartAttendee.attendeeTypeId, "-").concat(cartAttendee.unitTotal.toString()))) {
                var att = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.find(function (a) { return a.id === cartAttendee.attendeeTypeId; });
                if (att) {
                    consolidatedAttendeeItems["".concat(cartAttendee.attendeeTypeId, "-").concat(cartAttendee.unitTotal.toString())] = {
                        item_name: "".concat(event.titleInfo, " (").concat(att.name, ")"),
                        currency: event.currency,
                        price: cartAttendee.unitTotal,
                        quantity: 0,
                    };
                }
            }
            if (consolidatedAttendeeItems["".concat(cartAttendee.attendeeTypeId, "-").concat(cartAttendee.unitTotal.toString())]) {
                consolidatedAttendeeItems["".concat(cartAttendee.attendeeTypeId, "-").concat(cartAttendee.unitTotal.toString())]
                    .quantity++;
            }
        });
        if (analyticsStateData.googleProperties.length) {
            var payload = {
                transaction_id: transactionId,
                currency: event.currency,
                value: total,
                items: Object.values(consolidatedAttendeeItems),
            };
            sendGoogleAnalyticsEvent("purchase", payload);
            if (debugMode) {
                console.log("GA Event: Purchase");
            }
        }
        if (analyticsStateData.facebookIds.length) {
            var payload = {
                num_items: cart.attendeeCount,
                currency: event.currency,
                value: total,
                contents: Object.values(consolidatedAttendeeItems).map(function (i) { return ({
                    id: i.item_name,
                    quantity: i.quantity,
                }); }),
            };
            ReactPixel.track("Purchase", payload);
        }
    };
    var logPageview = function () {
        sendGoogleAnalyticsEvent("page_view", {});
        ReactPixel.pageView();
    };
    return (_jsx(AnalyticsContext.Provider, __assign({ value: {
            data: analyticsStateData,
            setGoogleProperties: setGoogleProperties,
            clearGoogleProperties: clearGoogleProperties,
            addToCart: addToCart,
            removeFromCart: removeFromCart,
            startCheckout: startCheckout,
            purchase: purchase,
            logPageview: logPageview,
            setFacebookIds: setFacebookIds,
            clearFacebookIds: clearFacebookIds,
        } }, { children: children })));
};
export default AnalyticsProvider;
